import createIcon from '../../createIcon';

/**
 * @component @name Pentagon
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiA5LjVMNiAyMS41SDE4TDIyIDkuNUwxMiAyLjVMMiA5LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Pentagon = createIcon('Pentagon', [
  ['path', { d: 'M2 9.5L6 21.5H18L22 9.5L12 2.5L2 9.5Z', key: 'jbj2t0' }],
]);

export default Pentagon;
